import { createRoot } from 'react-dom/client';
import { initializeApp } from 'firebase/app';
import { App as AdminApp } from './apps/admin/App';
import { App as ClientApp } from './apps/client/App';
import { ServiceFactory } from './services/firestore/ServiceFactory';
import { AuthService as ClientAuthService } from './services/api/AuthService';
import firebaseConfig from './assets/json/firebaseConfig.json';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const container = document.getElementById('app');
const root = createRoot(container);
const path = window.location.pathname;
const isAdmin = path.startsWith('/admin');

if(isAdmin) {
  // initialize Firebase
  const app = initializeApp(firebaseConfig);
  const auth = getAuth(app);
  const isTestRun = window.navigator.webdriver === true;
  const database = getFirestore(app, isTestRun ? 'test' : '');
  const serviceFactory = new ServiceFactory(database, auth);
  root.render(<AdminApp serviceFactory={serviceFactory} />);
}
else {
  const clientName = window.location.pathname.split('/')[1];
  const instanceName = 'broox-studio-' + clientName;
  const authService = new ClientAuthService(instanceName);
  root.render(<ClientApp authService={authService} clientName={clientName} />);
}
